(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["before-after-gallery"] && !Shopify.designMode) return;
  try {
    
class BeforeAfterGallery {
  constructor() {
    this.grid = document.getElementById('before-after-grid');
    this.loadMoreButton = document.getElementById('load-more-button');
    this.modal = document.getElementById('before-after-modal');
    this.modalImage = document.getElementById('modal-image');
    this.modalClose = document.getElementById('modal-close');
    this.modalPrev = document.getElementById('modal-prev');
    this.modalNext = document.getElementById('modal-next');
    
    this.currentPage = 0;
    this.imagesPerLoad = parseInt(this.loadMoreButton?.getAttribute('data-images-per-load') || 12);
    this.totalImages = 65; // Images 1.png to 65.png
    this.excludedImages = [11, 13, 16, 20, 23, 25, 27, 29, 39, 43, 45, 46, 47, 48, 53, 56, 57, 59]; // Removed images
    this.loadedImages = [];
    this.currentModalIndex = 0;
    
    // Get asset URLs from JSON
    const assetsData = document.getElementById('before-after-assets');
    this.assetConfig = assetsData ? JSON.parse(assetsData.textContent) : { assetUrlBase: '/assets/', sampleUrl: '/assets/1.png' };
    
    this.init();
  }
  
  init() {
    this.loadImages();
    this.bindEvents();
  }
  
  bindEvents() {
    this.loadMoreButton?.addEventListener('click', () => this.loadMoreImages());
    this.modalClose?.addEventListener('click', () => this.closeModal());
    this.modalPrev?.addEventListener('click', () => this.showPrevImage());
    this.modalNext?.addEventListener('click', () => this.showNextImage());
    
    // Close modal on escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') this.closeModal();
      if (e.key === 'ArrowLeft') this.showPrevImage();
      if (e.key === 'ArrowRight') this.showNextImage();
    });
    
    // Close modal on backdrop click
    this.modal?.addEventListener('click', (e) => {
      if (e.target === this.modal) this.closeModal();
    });
  }
  
  loadImages() {
    let loaded = 0;
    let currentImageNumber = this.currentPage * this.imagesPerLoad + 1;
    
    while (loaded < this.imagesPerLoad && currentImageNumber <= this.totalImages) {
      // Skip excluded images
      if (!this.excludedImages.includes(currentImageNumber)) {
        this.createImageElement(currentImageNumber);
        loaded++;
      }
      currentImageNumber++;
    }
    
    this.currentPage++;
    
    // Hide load more button if we've processed all possible images
    const availableImages = Array.from({length: this.totalImages}, (_, i) => i + 1)
      .filter(num => !this.excludedImages.includes(num));
    if (this.loadedImages.length >= availableImages.length) {
      this.loadMoreButton?.style.setProperty('display', 'none');
    }
  }
  
  loadMoreImages() {
    this.loadImages();
  }
  
  createImageElement(imageNumber) {
    const imageItem = document.createElement('div');
    imageItem.className = 'before-after-gallery__item';
    imageItem.setAttribute('data-image-index', this.loadedImages.length);
    
    const img = document.createElement('img');
    // Use the asset URL pattern from the sample URL
    const sampleUrl = this.assetConfig.sampleUrl;
    img.src = sampleUrl.replace('1.png', `${imageNumber}.png`);
    img.alt = `Before & After Result ${imageNumber}`;
    img.className = 'before-after-gallery__image';
    img.loading = 'lazy';
    img.width = 400;
    img.height = 400;
    
    // Add click event to open modal
    imageItem.addEventListener('click', () => {
      this.openModal(this.loadedImages.length);
    });
    
    imageItem.appendChild(img);
    this.grid?.appendChild(imageItem);
    
    this.loadedImages.push({
      src: img.src,
      alt: img.alt
    });
  }
  
  openModal(index) {
    this.currentModalIndex = index;
    this.modalImage.src = this.loadedImages[index].src;
    this.modalImage.alt = this.loadedImages[index].alt;
    this.modal?.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  
  closeModal() {
    this.modal?.classList.remove('is-open');
    document.body.style.overflow = '';
  }
  
  showPrevImage() {
    if (this.currentModalIndex > 0) {
      this.currentModalIndex--;
      this.modalImage.src = this.loadedImages[this.currentModalIndex].src;
      this.modalImage.alt = this.loadedImages[this.currentModalIndex].alt;
    }
  }
  
  showNextImage() {
    if (this.currentModalIndex < this.loadedImages.length - 1) {
      this.currentModalIndex++;
      this.modalImage.src = this.loadedImages[this.currentModalIndex].src;
      this.modalImage.alt = this.loadedImages[this.currentModalIndex].alt;
    }
  }
}

// Initialize when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  new BeforeAfterGallery();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  // Mega Menu and Dropdown Functionality
  class MegaMenuManager {
    constructor() {
      this.megaMenus = document.querySelectorAll('.jasi-mega-menu');
      this.dropdownMenus = document.querySelectorAll('.jasi-dropdown-menu');
      this.navItems = document.querySelectorAll('[data-mega-menu]');
      this.dropdownItems = document.querySelectorAll('[data-dropdown-menu]');
      this.activeMenu = null;
      this.timeout = null;

      this.init();
    }

    init() {
      // Handle mega menus
      this.navItems.forEach((navItem) => {
        const menuType = navItem.getAttribute('data-mega-menu');
        const megaMenu = document.getElementById(`mega-menu-${menuType}`);

        if (megaMenu) {
          // Mouse enter - show menu
          navItem.addEventListener('mouseenter', () => {
            this.showMenu(megaMenu);
          });

          // Mouse leave - hide menu after delay
          navItem.addEventListener('mouseleave', () => {
            this.scheduleHideMenu(megaMenu);
          });

          // Keep menu open when hovering over it
          megaMenu.addEventListener('mouseenter', () => {
            this.clearHideTimeout();
          });

          // Hide menu when leaving it
          megaMenu.addEventListener('mouseleave', () => {
            this.hideMenu(megaMenu);
          });
        }
      });

      // Handle dropdown menus
      this.dropdownItems.forEach((dropdownItem) => {
        const menuType = dropdownItem.getAttribute('data-dropdown-menu');
        const dropdownMenu = document.getElementById(`dropdown-menu-${menuType}`);

        if (dropdownMenu) {
          // Mouse enter - show dropdown
          dropdownItem.addEventListener('mouseenter', () => {
            this.showMenu(dropdownMenu);
          });

          // Mouse leave - hide dropdown after delay
          dropdownItem.addEventListener('mouseleave', () => {
            this.scheduleHideMenu(dropdownMenu);
          });

          // Keep dropdown open when hovering over it
          dropdownMenu.addEventListener('mouseenter', () => {
            this.clearHideTimeout();
          });

          // Hide dropdown when leaving it
          dropdownMenu.addEventListener('mouseleave', () => {
            this.hideMenu(dropdownMenu);
          });
        }
      });

      // Close on escape key
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
          this.hideAllMenus();
        }
      });

      // Close when clicking outside
      document.addEventListener('click', (e) => {
        if (!e.target.closest('.jasi-header__nav-item-container')) {
          this.hideAllMenus();
        }
      });
    }

    showMenu(megaMenu) {
      this.clearHideTimeout();
      this.hideAllMenus();

      megaMenu.classList.add('is-visible');
      this.activeMenu = megaMenu;

      // Add body class to prevent scroll if needed
      document.body.classList.add('mega-menu-open');
    }

    hideMenu(megaMenu) {
      megaMenu.classList.remove('is-visible');
      if (this.activeMenu === megaMenu) {
        this.activeMenu = null;
      }

      // Remove body class
      if (!document.querySelector('.jasi-mega-menu.is-visible')) {
        document.body.classList.remove('mega-menu-open');
      }
    }

    hideAllMenus() {
      this.megaMenus.forEach((menu) => {
        this.hideMenu(menu);
      });
      this.dropdownMenus.forEach((menu) => {
        this.hideMenu(menu);
      });
    }

    scheduleHideMenu(megaMenu) {
      this.timeout = setTimeout(() => {
        this.hideMenu(megaMenu);
      }, 150);
    }

    clearHideTimeout() {
      if (this.timeout) {
        clearTimeout(this.timeout);
        this.timeout = null;
      }
    }
  }

  // Initialize mega menu when DOM is loaded
  document.addEventListener('DOMContentLoaded', () => {
    new MegaMenuManager();
  });

  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 1400px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // Safety-net: close the search modal directly without going through
  // details-modal.close(), which currently throws because of a broken
  // trapFocusHandlers reference in global.js (loaded twice → TDZ).
  document.addEventListener('click', function (event) {
    var closeBtn = event.target.closest('.search-modal__close-button');
    if (!closeBtn) return;
    var modal = closeBtn.closest('details-modal');
    if (!modal) return;
    var details = modal.querySelector('details');
    if (details) details.removeAttribute('open');
    document.body.classList.remove('overflow-hidden');
  });

  // Lock body scroll while the mobile drawer is open. Dawn's openMenuDrawer
  // throws on trapFocus before reaching its body.classList.add call (same
  // global.js TDZ bug), so we mirror the toggle ourselves by observing the
  // [open] attribute on the drawer's <details>.
  var mobileDrawerDetails = document.getElementById('Details-menu-drawer-container');
  if (mobileDrawerDetails && 'MutationObserver' in window) {
    new MutationObserver(function () {
      document.body.classList.toggle(
        'overflow-hidden-tablet',
        mobileDrawerDetails.hasAttribute('open')
      );
    }).observe(mobileDrawerDetails, { attributes: true, attributeFilter: ['open'] });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pre-post-care"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const tabButtons = document.querySelectorAll('[data-tab-button]');
    const tabContents = document.querySelectorAll('[data-tab-content]');

    if (!tabButtons.length) return;

    for (const button of tabButtons) {
      button.addEventListener('click', (event) => {
        const clickedButton = event.currentTarget;
        const targetId = clickedButton.getAttribute('data-tab-button');

        for (const btn of tabButtons) {
          btn.classList.remove('pre-post-care__tab--active');
          btn.setAttribute('aria-selected', 'false');
        }

        for (const content of tabContents) {
          content.classList.remove('pre-post-care__content--active');
        }

        clickedButton.classList.add('pre-post-care__tab--active');
        clickedButton.setAttribute('aria-selected', 'true');

        const targetContent = document.querySelector(`[data-tab-content="${targetId}"]`);
        if (targetContent) {
          targetContent.classList.add('pre-post-care__content--active');
        }
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
